export default __webpack_public_path__ + "static/bankid-new-0b9e8a3c6669a87caea5b971952c999d.jpg";